import {combineReducers} from "redux"
import AuthReducer from "./AuthReducer"
import UserReducer from "./UserReducer"
import VisitorReducer from "./VisitorReducer"
import ProjectTypeReducer from "./ProjectTypeReducer"
import RolesAndPermissionsReducer from "./RolesAndPermissionsReducer"
import CreativeWorkReducer from "./CreativeWorkReducer"
import EvaluationTypeReducer from "./EvaluationTypeReducer"
import EvaluationDetailsReducer from "./EvaluationDetailsReducer"
import StatisticsReducer from "./StatisticsReducer"
import SettingsReducer from "./SettingsReducer"
import NotificationsReducer from "./NotificationsReducer"
import ProfileReducer from "./ProfileReducer"
import ProjectsReducer from "./ProjectsReducer"
import StatementsReducer from "./accounting-reducers/StatementsReducer"
import AccountsReducer from "./accounting-reducers/AccountsReducer"
import TransactionsReducer from "./accounting-reducers/TransactionsReducer"
import ExpensesReducer from "./accounting-reducers/ExpensesReducer"
import WarehousesReducer from "./warehouses-reducers/WarehousesReducer"
import ProductsReducer from "./warehouses-reducers/ProductsReducer"
import CategoryReducer from "./warehouses-reducers/CategoryReducer"
import SubcategoryReducer from "./warehouses-reducers/SubcategoryReducer"
import SupplyReducer from "./warehouses-reducers/SupplyReducer"
import SuppliersReducer from "./warehouses-reducers/SuppliersReducer"
import RequestsReducer from "./warehouses-reducers/RequestsReducer"
import OrdersReducer from "./warehouses-reducers/OrdersReducer"
import DeliveryReducer from "./warehouses-reducers/DeliveryReducer"
import ZoneReducer from "./warehouses-reducers/ZoneReducer"
import ZoneTypeReducer from "./warehouses-reducers/ZoneTypeReducer"
import ScriptArchiveReducer from "./ScriptArchiveReducer"
import AccountTypeReducer from "./accounting-reducers/AccountTypeReducer"
import VcardReducer from "./vcards-reducers/VcardReducer"

export default combineReducers({
    auth: AuthReducer,
    user: UserReducer,
    visitor: VisitorReducer,
    projectType: ProjectTypeReducer,
    role: RolesAndPermissionsReducer,
    creative_work: CreativeWorkReducer,
    evaluations : EvaluationTypeReducer,
    evaluationDetail : EvaluationDetailsReducer,
    statistic : StatisticsReducer,
    setting : SettingsReducer,
    notification : NotificationsReducer,
    profile: ProfileReducer,
    warehousee: WarehousesReducer,
    productt: ProductsReducer,
    categoriess: CategoryReducer,
    subCategory: SubcategoryReducer,
    projectss: ProjectsReducer,
    supply : SupplyReducer,
    suppliers: SuppliersReducer,
    requestss: RequestsReducer,
    orderss: OrdersReducer,
    delivery: DeliveryReducer,
    zonesType : ZoneTypeReducer,
    zones: ZoneReducer,
    accountss: AccountsReducer,
    transactionss: TransactionsReducer,
    statementss: StatementsReducer,
    expensess: ExpensesReducer,
    ScriptArchivee: ScriptArchiveReducer,
    accountTypees: AccountTypeReducer,
    vcardsRed: VcardReducer
})